export const generateSelectedLocationText = ({
	cityName,
	regionName,
	country,
	countryName,
	t,
}) => {
	if (cityName && regionName && country && country !== "all") {
		return `${cityName}, ${regionName}, ${t(`countries:${country}`)}`;
	} else if (regionName && country && country !== "all") {
		return `${regionName}, ${t(`countries:${country}`)}`;
	} else if (country && cityName && country !== "all") {
		return `${cityName}, ${t(`countries:${country}`)}`;
	} else if (
		countryName !== undefined &&
		countryName !== null &&
		country !== "all"
	) {
		return countryName;
	} else if (country && country !== "all") {
		return t(`countries:${country}`);
	} else {
		return "";
	}
};
